import axiosRequest from './restapi';

export const getNotes = (userToken: string) => {
  return axiosRequest(
    {
      method: 'get',
      url: '/users/notes',
    },
    userToken
  );
};

export const setNotes = (message: string, candidateId: string, userToken: string) => {
  return axiosRequest(
    {
      method: 'post',
      url: '/users/note',
      data: {
        message,
        candidateId,
      },
    },
    userToken
  );
};

export const updateNotes = (message: string, noteId: string, userToken: string) => {
  return axiosRequest(
    {
      method: 'patch',
      url: `/users/note/${noteId}`,
      data: { message },
    },
    userToken
  );
};
